var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" 产品利益演示 "),_c('inside-bar-chart',{staticClass:"mt30",attrs:{"data":_vm.data,"options":_vm.options,"adjust":"dodge"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }